import React, { Component } from 'react'
import { toast } from 'react-toastify'
import _ from 'lodash'
import Moment from 'moment'

import { Get, Post, PostNotification, Put } from 'utils/axios'
import getDomainURL from 'utils/api'
import firebase from '../../../../firebase'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      newMedicalRecord: {
        complaints: '',
        observations: '',
        notes: '',
        appointment_id: 0
      },
      selectedAppointmentMedicalRecord: null,
      medicalRecords: []
    }

    load = param => this.setState({ loading: param })
    requestError = error => toast.error( error )
    requestSuccess = success => toast.success( success )

    onChangeMedicalRecordsHOC = ( key, val ) => this.setState({ [key]: val })

    getMedicalRecords = patient_id => Get(
      `/medical_records/retrieve_from_patient?patient_id=${ patient_id }`,
      this.getMedicalRecordsSuccess,
      this.getMedicalRecordsError,
      this.load
    )
    getMedicalRecordsSuccess = payload => {
      let tmp = []
      if( payload && payload.length > 0 ) { 
        payload.map(( item, index ) => {
          tmp.push({
            ...item,
            is_editable: payload.length === index
          })
        })
      }
      this.setState({ 
        medicalRecords: tmp
      })
    }
    getMedicalRecordsError = error => this.requestError( error )

    getSelectedAppointmentTreatmentRecord = appointment_id => Get(
      `/medical_records/retrieve_from_appointment?appointment_id=${ appointment_id }`,
      this.getSelectedAppointmentTreatmentRecordSuccess,
      this.getSelectedAppointmentTreatmentRecordError,
      this.load
    )
    getSelectedAppointmentTreatmentRecordSuccess = payload => this.setState({ selectedAppointmentMedicalRecord: payload })
    getSelectedAppointmentTreatmentRecordError = error => this.requestError( error )

    createMedicalRecord = ( data, frontDeskId, patientName ) => Post(
      `/medical_records`,
      data,
      payload => this.createMedicalRecordSuccess( payload, frontDeskId, patientName ),
      this.createMedicalRecordError,
      this.load
    )
    createMedicalRecordSuccess = ( payload, frontDeskId, patientName ) => {
      this.getSelectedAppointmentTreatmentRecord( this.props.selectedAppointment.id )
      this.sendFirebaseNotificationToDr( frontDeskId, patientName, payload.id )
    }
    createMedicalRecordError = error => this.requestError( error )

    updateMedicalRecord = data => Put(
      `/medical_records/${ data.id }`,
      data,
      this.updateMedicalRecordSuccess,
      this.updateMedicalRecordError,
      this.load
    )
    updateMedicalRecordSuccess = payload => {}
    updateMedicalRecordError = error => this.requestError( error?.message || error )

    sendFirebaseNotificationToDr = ( frontDeskId, patientName, medicalRecordId ) => {
      let successMessage = 'Medical record is created successfully. Doctor can now check the patient treatment record under patient menu.'
      let notification =  {
        frontDeskId: frontDeskId,
        created_at: Moment().format(),
        message: `<p>Hey doctor, ${ patientName } ( patient ) is coming in, click <a href='${ 
          getDomainURL().indexOf( 'staging' ) > -1
            ? 'https://app-staging.primeview.site'
            : window.location.origin }/#/dashboard/patients/${ this.props.selectedAppointment.patient_id }/medical_record/${ medicalRecordId }'>here</a> to view his/her medical record.</p>` 
      }
      let firebaseNotification = {
        notification: {
          title: 'New Medical Record',
          body: notification,
          click_action: `${ getDomainURL().indexOf( 'staging' ) > -1
            ? 'https://app-staging.primeview.site'
            : window.location.origin }/#/dashboard/patients/${ this.props.selectedAppointment.patient_id }/medical_record/${ medicalRecordId }`,
          icon: 'data:image/png;base64,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',
        },
        to: ''
      }
      const userRef = getDomainURL().indexOf( 'staging' ) > -1
        ? firebase.database().ref( `stagingUsers/${ this.props.selectedAppointment.user_id }` ) 
        : getDomainURL().indexOf( 'idr' ) > -1
          ? firebase.database().ref( `productionUsersIdr/${ this.props.selectedAppointment.user_id }` ) 
          : firebase.database().ref( `productionUsers/${ this.props.selectedAppointment.user_id }` ) 

      userRef.once( 'value', snapshot => {
        let tmpNotificationList = []
        tmpNotificationList.push( notification )
        if( snapshot.exists() ){
          let tmpUser = {}
          if( snapshot.hasChild( 'token' ) ){
            tmpUser.token = snapshot.val().token
            firebaseNotification.to = snapshot.val().token
          }
          if( snapshot.hasChild( 'notifications' ) ){
            for( let id in snapshot.val().notifications ){
              tmpNotificationList.push( snapshot.val().notifications[ id ] )
            }
          }
          tmpUser.notifications = tmpNotificationList
          // userRef.set( tmpUser, () => this.sendNotification( firebaseNotification ) )
          userRef.set( tmpUser ).then( () => {
            this.requestSuccess( successMessage )
          })
        }
        else {
          let tmpUser = { notifications: tmpNotificationList  }
          userRef.set( tmpUser ).then( () => {
            this.requestSuccess( successMessage )
          })
        }
      })
    }

    sendNotification = data => PostNotification(
      data,
      this.sendNotificationSuccess,
      this.sendNotificationError,
      this.load
    )
    sendNotificationSuccess = () => console.log( 'Notification sent' )
    sendNotificationError = error => this.requestError( error )

    render = () => {
      return (
        <WrappedComponent
          { ...this.props }
          onLoadMedicalRecords={ this.state.loading }
          newMedicalRecord={ this.state.newMedicalRecord }
          selectedAppointmentMedicalRecord={ this.state.selectedAppointmentMedicalRecord }
          medicalRecords={ this.state.medicalRecords }
          getMedicalRecords={ this.getMedicalRecords }
          onChangeMedicalRecordsHOC={ this.onChangeMedicalRecordsHOC }
          getSelectedAppointmentTreatmentRecord={ this.getSelectedAppointmentTreatmentRecord }
          createMedicalRecord={ this.createMedicalRecord }
          updateMedicalRecord={ this.updateMedicalRecord } />
      )
    }
  }
  return WithHOC
}

export default HOC